module.exports = __webpack_public_path__ + "img/public/SiteIcons/hostStepIcons/localLaws.svg?902db5cf";